import { render, staticRenderFns } from "./Activity8.vue?vue&type=template&id=3595091e&scoped=true"
import script from "./Activity8.vue?vue&type=script&lang=js"
export * from "./Activity8.vue?vue&type=script&lang=js"
import style0 from "./Activity8.vue?vue&type=style&index=0&id=3595091e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595091e",
  null
  
)

export default component.exports